// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:05:12

export default {
  "id": "funny-walk-fail-run",
  "slug": "funny-walk-fail-run",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3232d8d696ec4bc1989cd0b4a0ec1482-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3232d8d696ec4bc1989cd0b4a0ec1482/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Funny Walk Fail Run",
      "description": "Funny Walk Fail Run is a fun-filled arcade action game with funny and magical gameplay! You will control a villain in the game to do challenges. But don't expect him to walk steadily, because he always falls and bumps in all sorts of funny positions! Your job is to help him navigate each step of the shaky road.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "activity",
        "arcade",
        "run"
      ]
    },
    "zh-CN": {
      "title": "滑稽走步失败跑",
      "description": "《搞笑走步失败跑》是一款充满乐趣的街机动作游戏，拥有有趣和魔法的游戏玩法！你将控制游戏中的反派角色来完成挑战。但别期待他能够稳步行走，因为他总是以各种搞笑的姿态跌倒和碰撞！你的任务是帮助他在这条摇摇晃晃的道路上每一步都顺利通过。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "活动",
        "街机",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "好笑的走路失敗跑",
      "description": "搞笑蹤跡失敗跑是一款充滿趣味的老式街機動作遊戲！你將控制遊戲中的惡棍進行挑戰。但別期待他穩穩當當地走路，因為他總是會跌倒並以各種搞笑的姿勢撞到東西！你的任務是幫助他通過每一步晃晃悠悠的道路。",
      "instructions": "滑鼠點擊或滑動按鈕來遊戲",
      "genres": [
        "休闲",
        "模擬"
      ],
      "tags": [
        "活動",
        "遊戲中心",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "搞笑行路失敗跑",
      "description": "搞笑行走路 Fail Run 是一場充滿樂趣的電子遊戲，遊戲玩法既有趣又神奇！你將控制遊戲中的惡棍進行挑戰。但別期待他能穩步走動，因為他總是會跌倒並以各種滑稽的姿勢撞倒！你的任務是幫助他穿越每一步摇曳的道路。",
      "instructions": "滑鼠點擊或輕觸以遊玩",
      "genres": [
        "隨意",
        "模擬"
      ],
      "tags": [
        "活動",
        "街機",
        "跑酷"
      ]
    },
    "ja": {
      "title": "面白い歩行失敗ラン",
      "description": "面白い歩行失敗ランは、面白くて魔法のようなゲームプレイが満載のアーケードアクションゲームです！ゲーム内でボスキャラクターを操作して挑戦を行いますが、彼がしっかりと歩くことを期待しないでください。なぜなら、彼はいつも様々な面白いポーズで転び、ぶつかるからです！あなたの仕事は、彼が揺れ動く道を一歩ずつ進むのを助けることです。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "アクティビティ",
        "アーケード",
        "ラン"
      ]
    },
    "ko": {
      "title": "웃긴 걸음 실패 달리기",
      "description": "미친 걸음 실패 달리기는 재미있는 아케이드 액션 게임으로, 웃긴 마법적인 게임플레이를 제공합니다! 당신은 게임에서 악당을 제어하여 도전을 하게 됩니다. 하지만 그가 안정적으로 걸을 것이라 기대하지 마세요, 그는 항상 웃기는 모습으로 떨어지고 부딪칩니다! 당신의 역할은 그가 흔들리는 길을 걸을 때마다 도와야 합니다.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "활동",
        "아케이드",
        "달리기"
      ]
    },
    "fr": {
      "title": "Échec de la course à la marche amusante",
      "description": "Funny Walk Fail Run est un jeu d'action arcade amusant avec une jouabilité drôle et magique ! Vous contrôlerez un méchant dans le jeu pour accomplir des défis. Mais ne vous attendez pas à ce qu'il marche stables, car il tombe et heurte en toutes sortes de positions drôles ! Votre tâche est de l'aider à naviguer sur chaque étape de la route instable.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Facile",
        "Simulation"
      ],
      "tags": [
        "activité",
        "arcade",
        "course"
      ]
    }
  }
};
